(function () {
  var MOBILE_BREAKPOINT = 750;

  function isDesktop() {
    return window.innerWidth >= MOBILE_BREAKPOINT;
  }

  function sync() {
    var desktop = isDesktop();
    document.querySelectorAll('.footer-block__details').forEach(function (el) {
      if (desktop) el.open = true;
    });
  }

  // Some browsers lose <summary>'s native click-to-toggle behaviour once
  // its default display is overridden (needed here for the flex layout
  // with the +/- icon), so the toggle is handled explicitly here instead
  // of relying on native <details> behaviour.
  function wireToggles() {
    document.querySelectorAll('.footer-block__summary').forEach(function (summary) {
      summary.addEventListener('click', function (event) {
        if (isDesktop()) return;
        event.preventDefault();
        var details = summary.closest('.footer-block__details');
        if (details) details.open = !details.open;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    sync();
    wireToggles();
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(sync, 150);
  });
})();
